import React from 'react';
import { AnyService } from '../../../types/service.type';
import EventsTab from './EventsTab';
import StatusTab from './StatusTab';
import LogsTab from './LogsTab';
import MonitoringTab from './MonitoringTab';

interface ServiceDetailTabsProps {
  service: AnyService;
  activeTab: string;
  onTabChange: (tab: string) => void;
}

const ServiceDetailTabs: React.FC<ServiceDetailTabsProps> = ({
  service,
  activeTab,
  onTabChange,
}) => {
  const tabs = [
    { id: 'events', label: 'Events' },
    { id: 'status', label: 'Status' },
    { id: 'logs', label: 'Logs' },
    { id: 'monitoring', label: 'Monitoring' },
  ];

  return (
    <div className="bg-white dark:bg-gray-800 rounded-lg border border-gray-200 dark:border-gray-700 overflow-hidden">
      {/* Tab Headers */}
      <div className="border-b border-gray-200 dark:border-gray-700">
        <div className="flex">
          {tabs.map((tab) => (
            <button
              key={tab.id}
              onClick={() => onTabChange(tab.id)}
              className={`px-6 py-4 text-sm font-medium transition-colors relative ${
                activeTab === tab.id
                  ? 'text-black dark:text-white'
                  : 'text-gray-500 hover:text-gray-700 dark:hover:text-gray-300'
              }`}
            >
              {tab.label}
              {activeTab === tab.id && (
                <div className="absolute bottom-0 left-0 right-0 h-0.5 bg-black dark:bg-white"></div>
              )}
            </button>
          ))}
        </div>
      </div>

      {/* Tab Content */}
      <div className="p-6">
        {activeTab === 'events' && <EventsTab service={service} />}
        {activeTab === 'status' && <StatusTab service={service} />}
        {activeTab === 'logs' && <LogsTab service={service} />}
        {activeTab === 'monitoring' && <MonitoringTab service={service} />}
      </div>
    </div>
  );
};

export default ServiceDetailTabs;